import { Box, Grid, IconButton, Typography } from "@mui/material";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import moment from "moment-jalaali";
import { useState } from "react";
import SelectionsTableDrug from "./selectionsTableDrug";
import EditIcon from "@/assets/SVG/editIcon";
import TrashIcon from "@/assets/SVG/trashIcon";
import CustomTable from "@/components/customTable/CustomTable";
import { archiveDrug, removeDrug } from "../../../api/group";
import EditDrugModal from "./editDrugModal";

export default function DrugTable({
  rowData,
  create,
  date,
  notGroup,
  setRowData,
  totalElements,
  onPageChange,
  pageSize,
  currentPage,
  showAddDrugToAreaFrom,
  setShowAddDrugToAreaFrom,
}) {
  const [openEditModal, setOpenEditModal] = useState(false);
  const [dataRowEdit, setDataRowEdit] = useState();

  const [selection, setSelection] = useState([]);

  const [colDefs] = useState([
    {
      headerName: "ردیف",
      headerCheckboxSelection: true,
      checkboxSelection: true,
      valueGetter: (params) => params.node.rowIndex + 1,
      width: 100,
    },
    {
      field: "drugType",
      headerName: "نوع دارو",
      width: 120,
    },
    {
      field: "name",
      headerName: "اسم دارو",
      width: 300,
    },
    {
      field: "code",
      headerName: "کد دارو",
      width: 120,
    },
    {
      field: "dose",
      headerName: "دوز دارو",
      width: 170,
    },
    {
      headerName: "تاریخ انقضا",
      width: 150,
      cellRenderer: (x, options = {}) => {
        const isMobile = options.mobile ?? false;
        return (
          <Box
            key={`expireAt_${x.id}`}
            display="flex"
            alignItems="center"
            justifyContent={isMobile ? "end" : "unset"}
          >
            {create ? (
              <Typography fontFamily="Vazirmatn">
                {`${date?.day} / ${date?.month} / ${date?.year} `}
              </Typography>
            ) : (
              <Typography fontFamily="Vazirmatn">
                {x.data?.expireAt?.split("T", 2)[0]}
              </Typography>
            )}
          </Box>
        );
      },
    },
    {
      field: "producer",
      headerName: "شرکت سازنده",
      width: 150,
    },
    {
      field: "available",
      headerName: "تعداد دانه",
      width: 140,
    },
    {
      field: "availablePack",
      headerName: "تعداد پک",
      width: 140,
    },
    {
      field: "price",
      headerName: "قیمت یک عدد",
      width: 160,
    },
    {
      headerName: "قیمت کل",
      width: 160,
      cellRenderer: (x, options = {}) => {
        const isMobile = options.mobile ?? false;
        return (
          <Box
            key={`totalPrice_${x.id}`}
            display="flex"
            alignItems="center"
            justifyContent={isMobile ? "end" : "unset"}
          >
            <Typography fontFamily="Vazirmatn">
              {(x.data?.price * x.data?.available).toLocaleString("fa-IR")}
            </Typography>
          </Box>
        );
      },
    },
    {
      field: "location",
      headerName: "محل دارو",
      width: 160,
    },
    {
      field: "boxNo",
      headerName: "شماره جعبه",
      width: 140,
    },
    {
      field: "shelfNo",
      headerName: "شماره قفسه",
      width: 140,
    },
    {
      headerName: "تاریخ انقضا",
      width: 200,
      cellRenderer: (x) => {
        const renderBox = (text, bgColor) => (
          <Box
            key={`expireAt_${x.id}`}
            width={"140px"}
            textAlign="center"
            bgcolor={bgColor}
            px="10px"
            borderRadius={"15px"}
            color="white"
            fontFamily="Vazirmatn"
          >
            {text}
          </Box>
        );

        const renderInvalidDate = (message) => renderBox(message, "#00000080");
        const renderExpiredDate = () =>
          renderBox("تاریخ انقضا گذشته", "#00000080");

        const expireAt = x.data?.expireAt;

        if (!expireAt) {
          return renderInvalidDate("تاریخ نامشخص");
        }

        const now = moment();

        // پارس تاریخ با فرمت مختلف (با یا بدون صفر)
        const end = moment(expireAt, ["jYYYY/jM/jD", "jYYYY/jMM/jDD"], true);

        if (!end?.isValid()) {
          console.log("Invalid date format:", expireAt);
          return renderInvalidDate("فرمت تاریخ نامعتبر");
        }

        const diffMs = end.diff(now);
        const duration = moment.duration(diffMs);

        if (diffMs <= 0) {
          return renderExpiredDate();
        }

        const totalDays = Math.floor(duration.asDays());
        const months = Math.floor(totalDays / 30);

        if (months >= 3) {
          return renderBox("بیش از سه ماه دیگر", "var(--emr-green)");
        }
        if (months >= 2) {
          return renderBox("دو ماه دیگر", "var(--emr-yellow)");
        }
        if (months >= 1) {
          return renderBox("یک ماه دیگر", "orange");
        }
        return renderBox(`${totalDays} روز دیگر`, "var(--emr-red)");
      },
    },
    {
      headerName: "عملیات",
      width: 200,
      cellRenderer: (x) => {
        return (
          <Grid key={`op_${x.id}`} display="flex" flexDirection={"row"}>
            <Box display="flex" alignItems="center">
              <IconButton
                onClick={() => {
                  removeDrug(x.data?.id)
                    .then(() => {
                      setRowData((z) => {
                        let array = [...z];
                        array = array.filter((item) => item.id !== x.data.id);
                        return array;
                      });
                    })
                    .catch(() => {});
                }}
              >
                <TrashIcon />
              </IconButton>
            </Box>
            <Box display="flex" alignItems="center">
              <Box
                width={"60px"}
                textAlign="center"
                px="10px"
                color="var(--emr-red)"
                fontFamily="Vazirmatn"
                onClick={() => {
                  archiveDrug(x.data?.id)
                    .then(() => {
                      setRowData((z) => {
                        let array = [...z];
                        array = array.filter((item) => item.id !== x.data.id);
                        return array;
                      });
                    })
                    .catch(() => {});
                }}
              >
                آرشیو
              </Box>
            </Box>
            <IconButton
              onClick={() => {
                setOpenEditModal(true);
                setDataRowEdit(x.data);
              }}
            >
              <EditIcon color="white" />
            </IconButton>
          </Grid>
        );
      },
    },
  ]);

  return (
    <>
      <EditDrugModal
        dataForm={dataRowEdit}
        setDataForm={setDataRowEdit}
        open={openEditModal}
        setOpen={setOpenEditModal}
        edit
      />
      {!showAddDrugToAreaFrom && (
        <>
          <CustomTable
            totalElements={totalElements}
            pageSize={pageSize}
            currentPage={currentPage}
            onPageChange={onPageChange}
            rowData={rowData}
            columns={colDefs}
            selection={selection}
            setSelection={setSelection}
          />
        </>
      )}

      {selection?.length > 0 && (
        <SelectionsTableDrug
          showAddDrugToAreaFrom={showAddDrugToAreaFrom}
          setShowAddDrugToAreaFrom={setShowAddDrugToAreaFrom}
          notGroup={notGroup}
          selection={selection}
          setSelection={setSelection}
        />
      )}
    </>
  );
}
